import { PendingToggle } from "@/pages/config/maintenance/schema/maintenance.schema";
import { Flex, Spinner, Switch, Text } from "@chakra-ui/react";
import { Check, X } from "lucide-react";
import { Controller } from "react-hook-form";
/**
 * Tipo de objeto que representa las props de un componente de fila de switch.
 */

interface MaintenanceSwitchRowProps {
  control: any;
  fieldName: string;
  label: string;
  disabled: boolean;
  showSpinner: boolean;
  onRequestConfirm: (args: PendingToggle) => void;
  codigoModulo: string;
  codigoSeccion: string;
}
/**
 * Componente de fila de switch para una sección.
 * @param props Props del componente.
 * @returns JSX del componente.
 */

export const MaintenanceSwitchRow = ({
  control,
  fieldName,
  label,
  disabled,
  showSpinner,
  onRequestConfirm,
  codigoModulo,
  codigoSeccion,
}: MaintenanceSwitchRowProps) => {
  return (
    <Flex width="100%" alignItems="center" justifyContent="space-between">
      <Text fontSize="14px">{label}</Text>
      <Flex alignItems="center" gap="10px">
        {showSpinner && <Spinner size="sm" />}
        <Controller
          control={control}
          name={fieldName}
          render={({ field }) => (
            <Switch.Root
              size={"lg"}
              checked={Boolean(field.value)}
              disabled={disabled}
              onCheckedChange={({ checked }) => {
                const prev = Boolean(field.value);
                field.onChange(checked);
                onRequestConfirm({
                  fieldName,
                  prevValue: prev,
                  nextValue: checked,
                  codigoModulo,
                  codigoSeccion,
                });
              }}
            >
              <Switch.HiddenInput />
              <Switch.Control>
                <Switch.Thumb>
                  <Switch.ThumbIndicator fallback={<X color="black" size={16}/>}>
                    <Check color="black" size={16}/>
                  </Switch.ThumbIndicator>
                </Switch.Thumb>
              </Switch.Control>
            </Switch.Root>
          )}
        />
      </Flex>
    </Flex>
  );
};
